import { render, staticRenderFns } from "./InfoItemPage.vue?vue&type=template&id=59026e59&scoped=true&"
import script from "./InfoItemPage.vue?vue&type=script&lang=js&"
export * from "./InfoItemPage.vue?vue&type=script&lang=js&"
import style0 from "./InfoItemPage.vue?vue&type=style&index=0&id=59026e59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59026e59",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/info_item_page.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Finfo%2FInfoItemPage.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports